/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: ['popper'],
    baseStyle: {
        popper: {
            borderColor: 'transparent',
            borderRadius: 'base',
            boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'
        }
    },
    variants: {
        small: {},
        normal: {
            popper: {
                width: 286
            },
            header: {
                textAlign: 'left',
                fontWeight: 700,
                borderBottom: 'none',
                fontSize: 18,
                px: 7,
                paddingTop: 6
            },
            footer: {
                textAlign: 'left',
                fontSize: 14,
                px: 3,
                borderTop: 'none'
            },
            content: {
                width: 286
            },
            body: {
                py: 0
            }
        },
        fullWidth: {
            popper: {
                width: '100%',
                maxWidth: '100%',
                boxShadow: 'none',
                top: '0',
                right: 'auto',
                bottom: 'auto',
                left: '0'
            },
            content: {
                width: 'auto'
            }
        },
        chipTooltip: {
            popper: {
                borderColor: 'transparent',
                boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.15)'
            },
            content: {
                borderRadius: 'none',
                maxWidth: '19.6875rem'
            },
            closeButton: {
                padding: 0,
                margin: 1,
                position: null,
                float: 'right',

                '&:hover': {
                    background: 'none'
                },

                '.chakra-icon': {
                    width: '1rem',
                    height: '1rem',
                    lineHeight: '1rem'
                }
            },
            body: {
                pX: '0.75rem',
                paddingTop: '0.75rem',
                paddingBottom: '1.5rem'
            }
        },
        searchSuggestions: {
            popper: {
                boxShadow: '2px 2px 2px 0px rgba(0, 0, 0, 0.20)',
                width: 'full',
                maxWidth: '800px'
            },
            content: {
                width: 'full',
                borderRadius: 'none',
                border: 0,
                padding: {base: 4, lg: 8}
            }
        },
        feedbackReportTooltip: {
            popper: {
                // reset base styling
                borderColor: null,
                borderRadius: null,
                boxShadow: null
            },
            content: {
                '--popper-bg': 'colors.stokkeCore.black',
                '--popper-arrow-shadow-color': 'transparent',
                color: 'stokkeCore.white',
                padding: 2,
                textStyle: 'Regular Medium',
                gap: '1em',
                boxShadow: '0px 5px 15px 1px rgba(0, 0, 0, 0.12)',
                // reset base styling
                border: null,
                borderRadius: null
            },
            header: {
                textStyle: 'Semi Bold Medium',
                // reset base styling
                px: null,
                py: null,
                borderBottomWidth: null
            },
            body: {
                // reset base styling
                px: null,
                py: null
            }
        }
    },
    defaultProps: {
        variant: 'normal'
    }
}
